import axios from 'axios';
import user from '../utils/user';

export default {
  async getConfigs() {
    try {
      const response = await axios.get(
        `${process.env.VUE_APP_API_VIDA_URL}/endorsement/configs`,
        {
          headers: {
            Authorization: `Bearer ${user.getUserAuthToken()}`,
          },
        },
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async updateConfigs(configs) {
    try {
      const response = await axios.patch(
        `${process.env.VUE_APP_API_VIDA_URL}/endorsement/configs`,
        configs,
        {
          headers: {
            Authorization: `Bearer ${user.getUserAuthToken()}`,
          },
        },
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async getOperationType() {
    try {
      const response = await axios.get(
        `${process.env.VUE_APP_API_VIDA_URL}/endorsement/operation-type-configs/all`,
        {
          headers: {
            Authorization: `Bearer ${user.getUserAuthToken()}`,
          },
        },
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async createOperationType(operationTypePayload) {
    try {
      const response = await axios.post(
        `${process.env.VUE_APP_API_VIDA_URL}/endorsement/operation-type-configs`,
        operationTypePayload,
        {
          headers: {
            Authorization: `Bearer ${user.getUserAuthToken()}`,
          },
        },
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async updateOperationType(id, operationTypePayload) {
    try {
      const response = await axios.patch(
        `${process.env.VUE_APP_API_VIDA_URL}/endorsement/operation-type-configs/${id}`,
        operationTypePayload,
        {
          headers: {
            Authorization: `Bearer ${user.getUserAuthToken()}`,
          },
        },
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async deleteOperationType(operationTypeId) {
    try {
      const response = await axios.delete(
        `${process.env.VUE_APP_API_VIDA_URL}/endorsement/operation-type-configs/${operationTypeId}`,
        {
          headers: {
            Authorization: `Bearer ${user.getUserAuthToken()}`,
          },
        },
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async getOperationTypeHistory(operationTypeId) {
    try {
      const response = await axios.get(
        `${process.env.VUE_APP_API_VIDA_URL}/endorsement/operation-type-configs/${operationTypeId}/history`,
        {
          headers: {
            Authorization: `Bearer ${user.getUserAuthToken()}`,
          },
        },
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async getAllEditableFields() {
    try {
      const response = await axios.get(
        `${process.env.VUE_APP_API_VIDA_URL}/endorsement/operation-type-configs/all-editable-fields`,
        {
          headers: {
            Authorization: `Bearer ${user.getUserAuthToken()}`,
          },
        },
      );
      return response;
    } catch (error) {
      throw error;
    }
  },

  async getMessagingOptions(active = false) {
    try {
      const response = await axios.get(
        `${process.env.VUE_APP_API_VIDA_URL}/messaging/messages?active=${active}`,
        {
          headers: {
            Authorization: `Bearer ${user.getUserAuthToken()}`,
          },
        },
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};
